import { createAsyncThunk, createSlice, current } from '@reduxjs/toolkit';
import _ from 'lodash-es';

import callApi from '../apiService';
import objectFactory from '../objectFactory';

const initialState = {
  topics: [],
  wizardDbObjectShell: {
    controlling_instance: null,
    target_bendable_instance: null,
    table_name: 'topics',
    status: 'draft',
    raw_data: {}
  },
  status: 'idle',
};

const fetchDbObjectShells = async (options) => {
  console.log('topicsSlice.fetchDbObjectShells() options: ', options);
  options.limit = options.limit || 'all';

  try {
    const response = await callApi('getDbObjectShells', null, { params: options });
    console.log('topicsSlice.fetchDbObjectShells() response: ', response);
    return response.data;   // axios attribute
  } catch (error) {
    console.error('topicsSlice.fetchDbObjectShells() error: ', error.message);
  }
};

export const getDbObjectShells = createAsyncThunk(
  'topics/getDbObjectShells',
  async (options) => {
    const response = await fetchDbObjectShells(options);
    return { tableName: options.tableName, rows: response.payload };
  }
);

const fetchTopics = async (options) => {
  console.log('topicsSlice.fetchTopics() options: ', options);
  options.limit = options.limit || 'all';

  try {
    const response = await callApi('getTopics', { apiVersion: options?.apiVersion }, { params: options });
    console.log('topicsSlice.fetchTopics() response: ', response);
    return response.data;   // axios attribute
  } catch (error) {
    console.error('topicsSlice.fetchTopics() error: ', error.message);
  }
};

export const getTopics = createAsyncThunk(
  'topics/getTopics',
  async (options) => {
    console.log('topicsSlice.getTopics() options: ', options);
    const response = await fetchTopics(options);
    console.log('topicsSlice.getTopics() response: ', response);
    return { topics: response.payload.topics };
  }
);

export const buildWizardDbObjectShell = createAsyncThunk(
  'topics/buildWizardDbObjectShell',
  async (options) => {
    console.log('topicsSlice buildWizardDbObjectShell() options: ', options);
    const response = await fetchTopics(options);
    console.log('topicsSlice.buildWizardDbObjectShell() response: ', response);
    return { topic: (response.payload?.topics && response.payload.topics[0]) || null };
  }
);



export const topicsSlice = createSlice({
  name: 'topics',
  initialState,
  reducers: {
    mergeTopicWizardRootData: (state, action) => {
      console.log('topicsSlice mergeTopicWizardRootData before merge; state, action: ', current(state), action);
      // the .mergeWith() below can generate this error: Unhandled Rejection (Error): [Immer] Immer only supports setting array indices and the 'length' property
      // so let's avoid Immer with cloneDeep...
      // state.wizardDbObjectShell = _.mergeWith(state.wizardDbObjectShell, action.payload, (objValue, srcValue, key, object, source, stack) => {
      const stateCopy = _.cloneDeep(state.wizardDbObjectShell);
      const payloadCopy = _.cloneDeep(action.payload);
      state.wizardDbObjectShell = _.mergeWith(stateCopy, payloadCopy, (objValue, srcValue, key, object, source, stack) => {
        if (_.isArray(srcValue)) {
          return srcValue;              // allows empty arrays to overwrite existing arrays
        } else {
          return undefined;
        }
      });
      console.log('topicsSlice mergeTopicWizardRootData after merge; state: ', current(state));
    },
    mergeTopicWizardRawData: (state, action) => {
      console.log('topicsSlice mergeTopicWizardRawData before merge; state, action: ', current(state), action);
      // the .mergeWith() below can generate this error: Unhandled Rejection (Error): [Immer] Immer only supports setting array indices and the 'length' property
      // so let's avoid Immer with cloneDeep...
      // state.wizardDbObjectShell.raw_data = _.mergeWith(state.wizardDbObjectShell.raw_data, action.payload, (objValue, srcValue, key, object, source, stack) => {
      const stateCopy = _.cloneDeep(state.wizardDbObjectShell.raw_data);
      console.log('topicsSlice mergeTopicWizardRootData stateCopy: ', stateCopy);
      const payloadCopy = _.cloneDeep(action.payload);
      console.log('topicsSlice mergeTopicWizardRootData payloadCopy: ', payloadCopy);
      state.wizardDbObjectShell.raw_data = _.mergeWith(stateCopy, payloadCopy, (objValue, srcValue, key, object, source, stack) => {
        // console.log('topicsSlice mergeTopicWizardRawData objValue: ', objValue);
        // console.log('topicsSlice mergeTopicWizardRawData srcValue: ', srcValue);
        // console.log('topicsSlice mergeTopicWizardRawData key: ', key);
        // console.log('topicsSlice mergeTopicWizardRawData object: ', object);
        // console.log('topicsSlice mergeTopicWizardRawData source: ', source);
        if (_.isArray(srcValue)) {
          return srcValue;              // allows empty arrays to overwrite existing arrays
        } else {
          return undefined;
        }
      });

      console.log('topicsSlice mergeTopicWizardRawData after merge; state: ', current(state));
    },
    resetTopicWizardData: (state, action) => {
      console.log('topicsSlice resetWizardData; state, action: ', current(state), action);
      state.wizardDbObjectShell = {
        controlling_instance: null,
        target_bendable_instance: null,
        table_name: 'topics',
        status: 'draft',
        raw_data: {},
      };
    },
  },
  extraReducers: (builder) => {
    builder
  //   .addCase(getDbObjectShells.pending, (state) => {
  //     console.log('topicsSlice getDbObjectShells.pending state: ', state);
  //     state.status = 'loading';
  //   })
  //   .addCase(getDbObjectShells.fulfilled, (state, action) => {
  //     state.status = 'idle';
  //     console.log('topicsSlice getDbObjectShells.fulfilled action: ', action);
  //     state.currentDbObjectShells[action.payload.tableName] = action.payload.rows;
  //     // console.log('getDbObjectShells case; state: ', current(state));
  //   });
    .addCase(getTopics.pending, (state) => {
      console.log('topicsSlice getTopics.pending state: ', state);
      state.status = 'loading';
    })
    .addCase(getTopics.fulfilled, (state, action) => {
      state.status = 'idle';
      console.log('topicsSlice getTopics.fulfilled action: ', action);
      state.topics = action?.payload?.topics || [];
      // console.log('getTopics case; state: ', current(state));
    })
    .addCase(buildWizardDbObjectShell.pending, (state) => {
      console.log('topicsSlice buildWizardDbObjectShell.pending state: ', state);
      state.status = 'loading';
    })
    .addCase(buildWizardDbObjectShell.fulfilled, (state, action) => {
      state.status = 'idle';
      console.log('topicsSlice buildWizardDbObjectShell.fulfilled action: ', action);
      const topic = action?.payload?.topic;
      const targetBendableInstance = action?.meta?.arg?.target_bendable_instance || 'bendable-labs';
      const dbObjectShell = objectFactory.buildDbObjectShellFromTopicDocument(topic, targetBendableInstance);
      console.log('topicsSlice buildWizardDbObjectShell.fulfilled dbObjectShell: ', dbObjectShell);
      state.wizardDbObjectShell = dbObjectShell;  
      // console.log('buildWizardDbObjectShell case; state: ', current(state));
    });
},
});

export const {
  resetTopicWizardData,
  mergeTopicWizardRootData,
  mergeTopicWizardRawData,
} = topicsSlice.actions;

// for useSelector; state is complete store, not slice
export const selectCurrentWizardDbObjectShell = (state) => state.topics.wizardDbObjectShell;
export const selectTopics = (state) => state.topics.topics;

export default topicsSlice.reducer;
